// src/Pages/Home/ComoTrabajamos.jsx
import React from 'react';
import './ComoTrabajamos.css';

const ComoTrabajamos = () => {
  const steps = [
    {
      num: 1,
      title: 'Elegí el paquete',
      text: 'Conoce las opciones disponibles y si ninguno de estos refleja lo que estas buscando, podes solicitar una entrevista y juntos lo adaptamos.',
    },
    {
      num: 2,
      title: 'Reserva',
      text: 'Una vez que hayas elegido el paquete, comenzamos la reserva con la fecha de tu evento.',
    },
    {
      num: 3,
      title: 'Completa tus datos',
      text: 'Es necesario completar el formulario de datos a nombre de la persona a la que se va a generar el contrato.',
    },
    {
      num: 4,
      title: 'Pago',
      text: 'Después de completar datos, se efectua el pago del 50% del valor total del servicio que hayan elegido, de esta manera, la fecha quedara comprometida.',
    },
    {
      num: 5,
      title: 'Contrato',
      text: 'Una vez generado el pago, el contrato se generara de manera automática, dejando asentadas las clausulas para el servicio.',
    },
    {
      num: 6,
      title: 'Coordinacion creativa',
      text: 'Tendremos una reunión virtual o presencial para crear la idea. Tendras a disposición una guía con las ideas para tu producción basado en tus gustos y preferencias.',
    },
  ];

  return (
    <section className="hiw">
      {/* ── Header claro ── */}
      <div className="hiw__header" data-aos="fade-up">
        <h2 className="hiw__title">¿Cómo trabajamos?</h2>
        <p className="hiw__subtitle">
          Mi diferencial, es que mis sesiones son únicas
          <br />
          ¿Cómo logramos esto?
        </p>
      </div>

      {/* ── Fondo oscuro con grid de pasos ── */}
      <div className="hiw__body">
        <div className="hiw__grid">
          {steps.map(({ num, title, text }) => (
            <div className="hiw__card" key={num} data-aos="fade-up">
              <span className="hiw__num">{num}</span>
              <h3 className="hiw__card-title">{title}</h3>
              <p className="hiw__card-text">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComoTrabajamos;